import { NgModule } from '@angular/core';
import { AuthGuard, canActivate } from '@angular/fire/auth-guard';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AUTH, CART, CHAT, FAVORITES, ORDERS, PAYMENT, SALES, SEARCH, SELL, VOUCHER } from './constants/routes.const';
import { redirectUnauthorized } from './guards/auth.guard';
import { BankGuard } from './guards/bank.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
  },
  {
    path: AUTH,
    loadChildren: () => import('./pages/auth/auth.module').then( m => m.AuthPageModule)
  },
  {
    path: SEARCH.BASE,
    loadChildren: () => import('./pages/home/search/search.module').then( m => m.SearchPageModule)
  },
  // SELL
  {
    path: SELL.CATEGORIES,
    loadChildren: () => import('./pages/sell/categories/categories.module').then( m => m.CategoriesPageModule)
  },
  {
    path: `${SELL.BASE}/${SELL.PUBLISH}`,
    loadChildren: () => import('./pages/sell/sell-publish/sell-publish.module').then( m => m.SellPublishPageModule),
    data: { authGuardPipe: redirectUnauthorized },
    canActivate: [AuthGuard, BankGuard]
  },
  {
    path: `${SELL.BASE}/${SELL.DETAIL}/:id`,
    loadChildren: () => import('./pages/sell/sell-detail/sell-detail.module').then( m => m.SellDetailPageModule)
  },
  {
    path: `${SELL.BASE}/${SELL.PUBLISH}/${SELL.SUCCESS}`,
    loadChildren: () => import('./pages/sell/sell-publish/sell-publish-success/sell-publish-success.module').then( m => m.SellPublishSuccessPageModule),
    ...canActivate(redirectUnauthorized)
  },
  {
    path: `${SELL.BASE}/${SELL.EDIT}/:id`,
    loadChildren: () => import('./pages/sell/sell-publish/sell-publish.module').then( m => m.SellPublishPageModule),
    ...canActivate(redirectUnauthorized)
  },
  // PROFILE
  {
    path: SALES.BASE,
    loadChildren: () => import('./pages/profile/sales/sales.module').then( m => m.SalesPageModule),
    ...canActivate(redirectUnauthorized)
  },
  {
    path: FAVORITES.BASE,
    loadChildren: () => import('./pages/profile/favorites/favorites.module').then( m => m.FavoritesPageModule),
    ...canActivate(redirectUnauthorized)
  },
  {
    path: `${ORDERS.BASE}`,
    loadChildren: () => import('./pages/profile/orders/orders.module').then( m => m.OrdersPageModule),
    ...canActivate(redirectUnauthorized)
  },
  {
    path: CHAT.BASE,
    loadChildren: () => import('./pages/profile/chat/chat.module').then( m => m.ChatPageModule),
    ...canActivate(redirectUnauthorized)
  },
  // CART
  {
    path: CART.SHIPPING,
    loadChildren: () => import('./pages/cart/shipping/shipping.module').then( m => m.ShippingPageModule),
    ...canActivate(redirectUnauthorized)
  },
  // PAYMENT
  {
    path: `${PAYMENT.BASE}/${PAYMENT.METHOD}`,
    loadChildren: () => import('./pages/cart/payment/payment-method/payment-method.module').then( m => m.PaymentMethodPageModule),
    ...canActivate(redirectUnauthorized)
  },
  {
    path: `${VOUCHER.BASE}`,
    loadChildren: () => import('./pages/voucher/voucher.module').then( m => m.VoucherPageModule)
  },
  {
    path: 'suggestions',
    loadChildren: () => import('./pages/suggestions/suggestions.module').then( m => m.SuggestionsPageModule)
  }

];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
